<div class="content__wrapper">
  <h2>Completá tus datos para continuar</h2>
  <p class="text-grey-500 mt-2">Necesitamos algunos datos más para emitir tu póliza.</p>
  <div class="content__wrapper--center mt-5">
    <app-user-update-form
      [user]="user()"
      [loading]="loading()"
      (userUpdated)="onUserUpdated($event)"
    />
    @if (errorMessage()) {
      <p class="text-danger-500 mt-3 text-center">{{ errorMessage() }}</p>
    }
  </div>
</div>
